import { render, staticRenderFns } from "./ProjectorInfo.vue?vue&type=template&id=04ef5759&scoped=true&"
import script from "./ProjectorInfo.vue?vue&type=script&lang=js&"
export * from "./ProjectorInfo.vue?vue&type=script&lang=js&"
import style0 from "./ProjectorInfo.vue?vue&type=style&index=0&id=04ef5759&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ef5759",
  null
  
)

export default component.exports